<nav class="flex mb-4" aria-label="Breadcrumb">
  <ol class="inline-flex items-center space-x-1 md:space-x-2">
    <!-- <li class="inline-flex items-center">
      <a routerLink="/dashboard"
        class="inline-flex items-center text-[10px] uppercase font-bold tracking-wider text-gray-400 hover:text-emerald-600 dark:text-gray-500 dark:hover:text-emerald-400 transition-colors">
        <svg class="w-3 h-3 mr-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
          viewBox="0 0 20 20">
          <path
            d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
        </svg>
        Home
      </a>
    </li> -->
    @for (breadcrumb of activeBreadcrumbs(); let i = $index; track breadcrumb.url) {
    <li>
      <div class="flex items-center">
        <svg *ngIf="i == 0" class="w-3 h-3 text-gray-300 dark:text-gray-600 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
          viewBox="0 0 20 20">
          <path
            d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
        </svg>
        <svg *ngIf="i > 0" class="w-3 h-3 text-gray-300 dark:text-gray-600 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
          fill="none" viewBox="0 0 6 10">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m1 9 4-4-4-4" />
        </svg>
        @if ($last) {
        <span class="ml-1 text-[10px] uppercase font-bold tracking-wider text-gray-500 dark:text-gray-300 md:ml-1">{{
          breadcrumb.label }}</span>
        } @else {
        <a [routerLink]="breadcrumb.url"
          class="ml-1 text-[10px] uppercase font-bold tracking-wider text-gray-400 hover:text-emerald-600 dark:text-gray-500 dark:hover:text-emerald-400 md:ml-1 transition-colors">{{
          breadcrumb.label }}</a>
        }
      </div>
    </li>
    }
  </ol>
</nav>